<template>
    <div v-if="curComponent && curComponent.componentLinks">
        <div v-for="(item, ind) in curComponent.componentLinks.links" :key="item.id" class="link-comp-item">
            <div class="link-comp-top">
                <el-select
                    v-model="item.comp"
                    :placeholder="$tt('请选择联动组件')"
                    @change="(val) => compChange(val, ind)"
                >
                    <el-option
                        v-for="comp in allComps"
                        :key="comp.value"
                        :label="comp.label"
                        :value="comp.value"
                        @mouseenter.native="handleLinkCompHover(comp)"
                        @mouseleave.native="handleLinkCompLeave(comp)"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="link-comp-top">
                <el-select v-model="item.listenEvent" :placeholder="$tt('请选择监听事件')">
                    <el-option
                        v-for="event in listenEventOptions(item)"
                        :key="event.value"
                        :label="event.label"
                        :value="event.value"
                    >
                    </el-option>
                </el-select>
            </div>
            <div>
                <p class="link-comp-title">事件触发时，当前组件要修改的属性</p>
                <div v-for="(attrItem, attrInd) in item.changeAttrs" :key="attrItem.id" class="link-attr-item">
                    <el-select v-model="attrItem.key" :placeholder="$tt('请选择')" class="link-attr-select">
                        <el-option
                            v-for="attr in attrOptions"
                            :key="attr.value"
                            :label="attr.label"
                            :value="attr.value"
                        >
                        </el-option>
                    </el-select>
                    <el-slider
                        v-if="['opacity'].includes(attrItem.key)"
                        v-model="attrItem.value"
                        :max="1"
                        :step="0.1"
                        class="link-attr-value"
                    >
                    </el-slider>
                    <el-input-number
                        v-else
                        class="link-attr-value"
                        v-model="attrItem.value"
                        :controls="false"
                        :min="0"
                        :placeholder="$tt('请输入')"
                    ></el-input-number>
                    <i class="el-icon-delete attr-delete" v-if="item.changeAttrs.length > 1" @click="deleteAttrClick(ind, attrInd)"></i>
                </div>
                <el-button size="small" @click="addAttrClick(ind)">{{ $tt("添加属性") }}</el-button>
            </div>
            <i class="el-icon-circle-close link-comp-delete" @click="deleteItemClick(ind)"></i>
        </div>
        <el-button size="small" @click="addCompClick">{{ $tt("添加组件") }}</el-button>
        <div class="link-transition-item">
            <p>过渡时间（毫秒）</p>
            <el-input-number
                v-model="curComponent.componentLinks.transitionTime"
                :controls="false"
                :min="0"
                :step="1"
                :step-strictly="true"
                style="width:100%;"
                :placeholder="$tt('请输入')"
            ></el-input-number>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { uuid } from "@/utils/utils";

export default {
    data() {
        return {
            datas: [
                { id: '', comp: '', listenEvent: '', changeAttrs: [{ id: '', key: '', value: '' }] }
            ],
            transitionTime: '',
            allComps: [],
            // listenEventOptions: [
            //     { label: '点击', value: 'click' },
            //     { label: '再次点击', value: 'clickAgain' }
            // ],
            // onceBtnListenOptions: [
            //     { label: '点击', value: 'click' }
            // ],
            attrOptions: [
                { label: '透明度', value: 'opacity' },
                { label: '宽度', value: 'width' },
                { label: '高度', value: 'height' },
                { label: 'x坐标', value: 'left' },
                { label: 'y坐标', value: 'top' }
            ]
        };
    },
    computed: {
        ...mapState([
            "componentData",
            "curComponent"
        ]),
        listenEventOptions() {
            return (item) => {
                var compData = this.componentData.filter(a => a.id === item.comp)
                if (compData && compData.length > 0) {
                    var isOneClickBtn = compData[0].style.oneClick;
                    if (isOneClickBtn) {
                        return [
                            { label: '点击', value: 'click' }
                        ]
                    }
                }
                return [
                    { label: '点击', value: 'click' },
                    { label: '再次点击', value: 'clickAgain' }
                ]
            }
        }
    },
    watch: {
        componentData: {
            handler: function(val, oldValue) {
                if (val && val.length !== 0) {
                    this.getAllComps();
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        compChange(val, ind) {
            this.$nextTick(() => {
                var item = this.curComponent.componentLinks.links[ind];
                var eventVal = this.curComponent.componentLinks.links[ind].listenEvent;
                var eventValInd = this.listenEventOptions(item).findIndex(a => a.value === eventVal)
                if (eventValInd === -1) {
                    // 置为空
                    this.curComponent.componentLinks.links[ind].listenEvent = '';
                }
            })
        },
        handleLinkCompHover(item) {
            var currentElem = document.getElementById("component" + item.value);
            currentElem.classList.add("link-select-hover");
        },
        handleLinkCompLeave(item) {
            var currentElem = document.getElementById("component" + item.value);
            currentElem.classList.remove("link-select-hover");
        },
        getAllComps() {
            // console.log('getAllComps--', this.curComponent);
            this.allComps = this.componentData.reduce((arr, item) => {
                if (!["Back", "EcologicalGroup"].includes(item.component) && this.curComponent.id !== item.id) {
                    arr.push({
                        label: item.label,
                        value: item.id
                    });
                }
                return arr;
            }, []);
        },
        addAttrClick(ind) {
            this.curComponent.componentLinks.links[ind].changeAttrs.push({ id: uuid(), key: '', value: undefined });
        },
        addCompClick() {
            this.curComponent.componentLinks.links.push({
                id: uuid(),
                comp: '',
                listenEvent: '',
                changeAttrs: [{ id: uuid(), key: '', value: undefined }]
            });
        },
        deleteItemClick(ind) {
            this.curComponent.componentLinks.links.splice(ind, 1);
        },
        deleteAttrClick(ind, attrInd) {
            this.curComponent.componentLinks.links[ind].changeAttrs.splice(attrInd, 1);
        }
    }
}
</script>
<style lang="scss">
.link-comp-top {
    .el-select {
        width: 100%;
    }
}
</style>
<style lang="scss" scoped>
.link-comp-item {
    border: 1px solid #dcdfe6;
    padding: 24px 10px 10px;
    margin: 12px 0px;
    position: relative;
    .link-comp-top + .link-comp-top {
        margin-top: 12px;
    }
    .link-comp-title {
        margin: 16px 0px;
    }
    .link-attr-item {
        display: flex;
        align-items: center;
        gap: 8px;
        min-width: 0;
        margin-bottom: 16px;
        .link-attr-select {
            width: 96px !important;
            flex: 0 0 96px;
        }
        .link-attr-value {
            flex: 1 1 auto !important;
            width: auto !important;
            min-width: 0 !important;
            max-width: none !important;
        }
        .attr-delete {
            flex-grow: 0;
            flex-shrink: 0;
            font-size: 17px;
            line-height: 32px;
            cursor: pointer;
        }
    }
    .link-comp-delete {
        position: absolute;
        top: 3px;
        right: 10px;
        cursor: pointer;
        font-size: 18px;
        color: #dcdfe6;
    }
}
.link-transition-item {
    margin-top: 12px;
    .el-input-number {
        width: 100% !important;
        max-width: 100%;
    }
}
</style>